<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">

            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户区域"
                      v-model="listQuery.entity.area.name">
            </el-input>

            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户名"
                      v-model="listQuery.entity.user.name">
            </el-input>
         <!--   <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="产品名"
                      v-model="listQuery.entity.wares.name">
            </el-input>-->

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <el-table-column align="center" label="序号">
                <template slot-scope="scope">
                    <span>{{scope.$index+1}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="用户区域">
                <template slot-scope="scope">
                    <span>{{scope.row.area.name}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="用户">
                <template slot-scope="scope">
                    <span>{{scope.row.user.name}}{{scope.row.user.code}}</span>
                </template>
            </el-table-column>
           <!-- <el-table-column align="center" label="产品">
                <template slot-scope="scope">
                    <span>{{scope.row.wares.name}}</span>
                </template>
            </el-table-column>-->
            <el-table-column align="center" label="金额">
                <template slot-scope="scope">
                    <span>{{scope.row.area.price}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" label="是否立即返利">-->
<!--                <template slot-scope="scope">-->
<!--                                                <span>-->

<!--                         <el-tag :type="listQuery.entity.area.tagTypes[scope.row.area.rewardType]">     {{listQuery.entity.area.rewardTypeOptions[scope.row.area.rewardType]}}</el-tag>-->

<!--                        </span>-->
<!--                </template>-->
<!--            </el-table-column>-->

            <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
<!--                <el-form-item label="代理级别" prop="name">-->

<!--                    <el-cascader-->
<!--                            :props="props"-->
<!--                            v-model="temp.area.name"-->
<!--                            :change-on-select="true"-->
<!--                            :clearable="true"-->
<!--                            :filterable="true"-->
<!--                            :options="addressData"-->
<!--                    ></el-cascader>-->
<!--                </el-form-item>-->

              <el-form-item label="用户区域" prop="userId">
                <el-input placeholder="市/县" v-model="temp.area.name"></el-input>
              </el-form-item>

                <el-form-item label="用户编号" prop="userId">
                    <el-input v-model="temp.user.code"></el-input>
                </el-form-item>

<!--                <el-form-item label="是否立即返利" prop="status">-->
<!--                    <el-select class="filter-item" v-model="temp.area.rewardType" placeholder="是否立即返利">-->
<!--                        <el-option v-for="(item,index) in  listQuery.entity.area.rewardTypeOptions" :key="item" :label="item"-->
<!--                                   :value="index">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
               <!-- <el-form-item label="产品" prop="goodsId">
                    <el-select v-model="temp.area.goodsId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in goodsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item label="该分金额比例" prop="price">
                    <el-input v-model="temp.area.price"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, save, update, remove} from '@/api/area'
    import waves from '@/directive/waves' // 水波纹指令


    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'
    import {addressData} from '@/utils/area'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                props: {
                    value: 'text',
                    label: 'text'
                },
                // goodsList: null,
                province: null,
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    json: true,
                    page: 1,
                    limit: 20,
                    order: 'area.id desc'
                    ,
                    entity: {

                        area: {

                            name: null
                            ,
                            userId: null

                            ,
                            rewardTypeOptions: ["否", "是"],
                            tagTypes:['info','','warning','danger','warning']
                        ,
                            price: null
                        },
                        user: {
                            name: null
                        },
                       /* wares: {
                            name: null
                        }*/
                    },

                },
                temp:
                    {
                        area: {
                            id: null, name: null, userId: null, rewardType: null, price: null
                        },
                        user: {code: null}

                    }
                ,
                dialogFormVisible: false,
                dialogStatus:
                    '',
                textMap:
                    {
                        update: '修改',
                        create:
                            '新增'
                    }
                ,
                rules:
                    {
                        name: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        userId: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                        ,
                        /*goodsId: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ],*/

                        rewardType: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'blur'
                            }
                        ]
                        ,
                        price: [
                            {
                                required: false, message:
                                    '必填字段', trigger:
                                    'change'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key:
                            ''
                    }
            }
        },
        created() {
            this.getList()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            addressData() {
                return addressData
            },
            canSave() {
                return hasAuth(this.perms, 'area:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'area:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'area:update')
            },
            canList() {
                return hasAuth(this.perms, 'area:list')
            }
        },
        methods: {
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })

            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片

            },
            // eslint-disable-next-line no-unused-vars
            afterFormShow(row) {

            },
            beforeFormCommit() {
            },
            resetTemp(row) {

                this.temp = {
                    area: {},
                    user: {}
                }
                if (row) {

                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.resetTemp()
             /*   goodsList().then(res => {
                    this.goodsList = res.data
                })*/
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                console.log(scope.$index)
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            // this.temp.area.name = this.temp.area.name.join('')
                            this.beforeFormCommit()
                            this.temp.json = true
                            console.log(this.temp)
                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.id]
                const ids = [this.list[this.index].area.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
              /*  goodsList().then(res => {
                    this.goodsList = res.data
                })*/
                this.index = scope.$index
                this.beforeFormShow(scope.row)
                this.dialogStatus = 'update'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].clearValidate()
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            console.log(this.temp)
                            console.log(this.temp.area.name instanceof Array)
                            if (this.temp.area.name instanceof Array) {
                                this.temp.area.name = this.temp.area.name.join('')
                            }
                            this.beforeFormCommit()
                            this.temp.json = true
                            update(this.temp).then(() => {
                                this.list.splice(this.index, 1, this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = [
                        '序号'
                        ,
                        '代理级别'
                        ,
                        '用户id'
                        ,
                        '产品id'
                        ,
                        '该分金额'
                        ,
                        '是否立即返利'

                    ]
                    const filterVal = ['id'
                        , 'name'
                        , 'userId'
                        // , 'goodsId'
                        , 'price',
                        'rewardType'

                    ]
                    const data = this.formatJson(filterVal, this.list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: 'table-list'
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                        return v[j]
                    }
                ))
            },
        }
    }
</script>
